/*
  Tap a hotspot dot to open its small name/role/bio card anchored right
  above the dot itself (no photo, no full-screen modal) - opening one closes
  any other that's already open, and clicking outside or pressing Escape
  closes whichever is open.
*/
(function () {
  const medias = document.querySelectorAll('.team__media');
  if (!medias.length) return;

  medias.forEach((media) => {
    const hotspots = Array.from(media.querySelectorAll('[data-hotspot]'));

    function closeAll(except) {
      hotspots.forEach((hotspot) => {
        if (hotspot === except) return;
        hotspot.classList.remove('is-active');
        const trigger = hotspot.querySelector('[data-hotspot-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    hotspots.forEach((hotspot) => {
      const trigger = hotspot.querySelector('[data-hotspot-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', (event) => {
        event.stopPropagation();
        const willOpen = !hotspot.classList.contains('is-active');
        closeAll(willOpen ? hotspot : null);
        hotspot.classList.toggle('is-active', willOpen);
        trigger.setAttribute('aria-expanded', String(willOpen));
      });
    });

    document.addEventListener('click', () => closeAll());
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });
  });
})();
